import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  LoseProjectMutation as LoseProjectMutationType,
  LoseProjectMutationVariables,
} from "./__generated__/LoseProjectMutation";

const LoseProjectMutation = loader("./LoseProjectMutation.gql");

type LoseProjectMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: LoseProjectMutationType) => void;
}) => ReactElement;

export const LoseProjectMutationProvider: LoseProjectMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<LoseProjectMutationType, LoseProjectMutationVariables>(
    LoseProjectMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
